// Angular
import { inject, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
// Guards
import { CustomerGuard } from './guards/customer.guard';
// Layouts
import { BaseLayoutComponent } from './layouts/base-layout';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
  {
    path: '',
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(CustomerGuard).canActivate(state)],
    component: BaseLayoutComponent,
    children: [
      { path: 'procedures', loadChildren: () => import('./modules/procedure/procedure.module').then(m => m.ProcedureModule) },
      { path: '', redirectTo: 'procedures', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '/procedures' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {

  constructor() {
  }
}
